import 'angular:locale/data:nl';
import 'zone.js';(globalThis.$localize ??= {}).locale = "nl";
